import React from 'react';
import { Dialog, DialogContent } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { Sparkles, ArrowRight } from 'lucide-react';

const CAT_WAVING = "https://static.prod-images.emergentagent.com/jobs/9146f3d9-a3b8-4907-acc0-5321df3c8e86/images/e0aebdb4136ccfbb07836d8a4918b929783a732c1a4be048d63bbb818f0ba07c.png";

export const WelcomePopup = ({ open, onClose, onSkip, userName }) => {
  
  const handleSkip = () => {
    if (onSkip) {
      onSkip();
    } else if (onClose) {
      onClose(false);
    }
  };
  
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && (onSkip ? onSkip() : onClose && onClose(false))}>
      <DialogContent className="sm:max-w-lg bg-slate-900 border-slate-700/60 text-center">
        <div className="py-6 space-y-5">
          {/* Cat mascot */}
          <div className="relative w-24 h-24 mx-auto">
            <div className="absolute inset-0 bg-cyan-500/15 rounded-full animate-pulse" />
            <img 
              src={CAT_WAVING} 
              alt="Shweebum cat" 
              className="relative w-24 h-24 object-contain drop-shadow-lg"
            />
          </div>

          <div>
            <h2 className="font-literary text-2xl text-white">
              Welcome{userName ? `, ${userName}` : ''}!
            </h2>
            <p className="text-lg text-cyan-400 font-medium mt-1">
              You just found your new favorite writing tool.
            </p>
          </div>

          <div className="text-slate-300 text-sm space-y-2 text-left bg-slate-800/70 border border-slate-700/50 p-4 rounded-lg">
            <p>
              Shweebum is where your imagination runs wild. This is the place where your stories come to life
              with AI that actually understands storytelling.
            </p>
            <p>
              Whether you know every chapter or just have a spark of an idea,
              Shweebum maps it, writes it, and keeps your characters and plot threads consistent from beginning to end.
            </p>
            <p className="font-medium text-white">
              This is going to be the greatest writing experience of your life. Let's get started.
            </p>
          </div>

          <div className="space-y-2">
            <Button
              onClick={() => onClose && onClose(false)}
              className="w-full bg-cyan-600 hover:bg-cyan-500 text-white text-base py-5"
              data-testid="welcome-start-btn"
            >
              <Sparkles className="w-5 h-5 mr-2" />
              Show Me Around
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            
            <button
              onClick={handleSkip}
              className="w-full text-sm text-slate-400 hover:text-slate-300 py-2"
              data-testid="welcome-skip-btn"
            >
              Skip, I'll figure it out myself
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
